import React, { FC } from 'react';
import { Typography, Box } from '@material-ui/core';
import Button from '../buttons';
import useStyles from './styles';
import AccountDropdown from '../account-dropdown';
import { useTranslation } from '../../hooks/useTranslation';
import PaperBox from '../utility/paper-box';
import { navigate } from 'gatsby';
import ROUTES from '../../routes';

interface Props {
  path?: string;
}

const MedicalCertificateConfirmation: FC<Props> = _ => {
  const { t, richT } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Box mt={2} mb={1}>
        <AccountDropdown />
      </Box>
      <PaperBox className={classes.copyBlock}>
        <Typography variant={'h4'}>
          {t('MEDICAL_CERTIFICATE_INELEGIBLE')}
        </Typography>
        <Typography variant={'body1'}>
          {richT('PLEASE_CALL_CUST_MON_FRIDAY')}
        </Typography>
        
      </PaperBox>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          marginTop: '.5em',
        }}
      >
        <Button
          variant={'contained'}
          color={'primary'}
          className={classes.submitButton}
          onClick={() => void navigate(ROUTES.ACCOUNT)}
        >
          {t('DONE')}
        </Button>
      </Box>
    </>
  );
};

export default MedicalCertificateConfirmation;
